import { useEffect, useRef, useState } from 'react';

import { useTournamentService } from 'hooks/tournament/useTournamentService';
import type TournamentService from 'services/tournament/tournamentService';
import { type TournamentRolesInterface } from 'typedefs/tournamentTypes';

export const useFetchTournamentRoles = (tournamentId?: string) => {
  const tournamentServiceRef = useRef<TournamentService>(null);
  tournamentServiceRef.current = useTournamentService();
  const [{ tournamentRoles, loading }, setTournamentRolesQuery] = useState<{
    tournamentRoles?: TournamentRolesInterface;
    loading?: boolean;
  }>({
    tournamentRoles: undefined,
    loading: true,
  });
  useEffect(() => {
    if (tournamentId) {
      tournamentServiceRef.current
        .getTournamentRoles(tournamentId)
        .then((result) => {
          setTournamentRolesQuery({ tournamentRoles: result.data.tournamentRoles, loading: false });
        })
        .catch(() => setTournamentRolesQuery({ tournamentRoles: undefined, loading: false }));
    }
  }, [tournamentId]);

  return { tournamentRoles, loading };
};
